/* eslint-disable @typescript-eslint/no-explicit-any */
import { JSX, ReactNode, UIEvent } from 'react';

import './table.scss';

import { Preloader } from '../preloader/preloader';

export interface ITableHeader {
	value: string;
	title?: string | JSX.Element;
	width?: string;
	minWidth?: string;
	maxWidth?: string;
	align?: 'left' | 'center' | 'right';
	nowrap?: boolean;
	formatted?: (row: any, ...params: any[]) => ReactNode;
	filter?: () => ReactNode | undefined;
	onChange?: (value: any) => void;
}

export interface ITableProps<T> {
	headers: ITableHeader[];
	rows: T[];
	pending: boolean;
	emptyText?: string;
	acceptRowClassName?: (row: T, i?: number) => string;
	onScroll?: (event: UIEvent<HTMLDivElement>) => void;
}

export default function Table<T>({
	headers,
	rows,
	acceptRowClassName,
	pending,
	emptyText = 'Записей не найдено',
	onScroll,
}: ITableProps<T>) {
	return (
		<div className="table-container">
			<div className="table-overlay" onScroll={onScroll}>
				{/* цвет, а не none: снятие рамки меняет высоту таблицы и порождает лишний scroll-event */}
				<table className="table-for-tabel" style={pending ? { borderBottomColor: 'transparent' } : {}}>
					<thead>
						<tr className="filter-row">
							{headers.map(header => (
								<th
									key={`filter-${header.value}`}
									style={{
										width: header.width,
										minWidth: header.minWidth,
										maxWidth: header.maxWidth,
									}}
								>
									<div className="filter-cell">{header.filter?.() || header.title}</div>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{pending && (
							<div className="loader-container">
								<Preloader />
							</div>
						)}
						{rows.length > 0 ? (
							rows.map((row, rowIndex) => (
								<tr
									key={`row-${rowIndex}`}
									className={`data-row ${acceptRowClassName?.(row, rowIndex)}`}
								>
									{headers.map((header, headerIndex) => (
										<td
											key={`${header.value}-${rowIndex}-${headerIndex}`}
											style={{
												textAlign: header.align || 'left',
												whiteSpace: header.nowrap ? 'nowrap' : 'normal',
											}}
										>
											{header.formatted ? header.formatted(row) : (row as any)[header.value]}
										</td>
									))}
								</tr>
							))
						) : (
							<tr className="empty-row">
								<td colSpan={headers.length}>
									<div className="empty-message">{emptyText}</div>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
